
function sliderObject(){
	if (!$('.js-app-slider').length) {
		return false;
	}
	let boxSlider = $('.js-app-slider');
	let Slider = $('.slider', boxSlider);
	let countSlider = $('.slide', boxSlider).length;

	boxSlider.find('.wrap-slider__counter-all').text(countSlider);
	Slider.each(function(index, el) {
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: $(this).closest(boxSlider).find('.js-slide--prev'),
			nextArrow: $(this).closest(boxSlider).find('.js-slide--next'),
			dots: false,
			infinite: false,
			// centerMode: true,
			// variableWidth: true,
		});
		boxSlider.find('.wrap-slider__counter-curent').text(1);
		$(this).on('afterChange', function(event, slick, currentSlide, nextSlide){
		  boxSlider.find('.wrap-slider__counter-curent').text(currentSlide + 1);
		  boxSlider.find('.wrap-slider__counter-all').text(countSlider);
		});
		
	});
}


function sliderObjectDestroy(){
	if (!$('.js-app-slider').length) {
		return false;
	}
	let boxSlider = $('.js-app-slider');
	let Slider = $('.slider', boxSlider);
	
	Slider.each(function(index, el) {
		if ($(this).hasClass('slick-initialized')) {
			$(this).slick('unslick');
		}
	});
}



/**
 * Инит модуля
 */
function init() {
	sliderObject();
}
function destroy() {
	sliderObjectDestroy();
}

module.exports = {
	init,
	destroy,
};
